import { NextSeo, ImageJsonLd } from 'next-seo';
import { useRouter } from 'next/router';
import { PUBLIC_HOST } from '@config/index';
import { ISeo } from '@typescript/index';
import { ICategorySeo } from '@features/categories/typescript';
import openGraphUrlCreator from '@utils/openGraphUrlCreator';

type PropsType = {
  seo: ISeo | ICategorySeo;
  title?: string;
};

const MainSeo = ({ seo, title = '' }: PropsType) => {
  const { asPath, locale } = useRouter();
  const mainTitle = seo.title || title;

  const getImagesJsonLd = (): ImageJsonLd[] => {
    if (!seo?.imagePaths || seo.imagePaths.length === 0) return [];
    return seo?.imagePaths.map((imagePath) => {
      let imageUrlPath = '';

      if (typeof imagePath === 'string') {
        imageUrlPath = imagePath;
      } else if (typeof imagePath === 'object' && imagePath && 'path' in imagePath) {
        imageUrlPath = (imagePath as { path: string }).path;
      }

      return {
        contentUrl: imageUrlPath,
        creator: {
          '@type': 'Organisation',
          name: 'VOX',
        },
        copyrightNotice: '© VOX',
        creditText: PUBLIC_HOST,
      };
    });
  };

  return (
    <>
      <NextSeo
        title={mainTitle}
        description={seo.description}
        openGraph={{
          type: seo['og:type'] ?? 'website',
          url: openGraphUrlCreator(asPath, locale),
          title: seo['og:title'] ?? mainTitle,
          description: seo['og:description'] ?? seo.description,
          images: seo['og:image']
            ? [
                {
                  url: seo['og:image'],
                  alt: seo['og:image.alt'],
                  type: 'image/jpeg',
                },
              ]
            : [],
        }}
        twitter={{
          handle: '@handle',
          site: '@site',
          cardType: 'summary_large_image',
        }}
      />
      {seo?.imagePaths && seo?.imagePaths.length > 0 && <ImageJsonLd images={getImagesJsonLd()} />}
    </>
  );
};
export default MainSeo;
